"use client"

import * as React from "react"
import { cn } from "../../lib/utils"
import { cva, VariantProps } from "class-variance-authority"


export const inputVariants = cva(
    "flex w-full border border-input bg-transparent rounded text-base transition-colors placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60 placeholder:text-sm",
    {
        variants: {
            variant: {
                default: "bg-white placeholder:text-muted-foreground/60 focus-visible:border-primary",
                destructive: "bg-destructive/10 focus-visible:border-destructive",
            },
            size: {
                default: "h-14 px-3 py-1 text-base ",
                sm: "h-10 px-3 py-1 text-sm",
                lg: "h-16 px-4 py-2 text-lg",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        }
    }
)


export interface InputProps extends
    Omit<React.ComponentProps<"input">, "size">,
    VariantProps<typeof inputVariants> {}


const Input = React.forwardRef<HTMLInputElement, InputProps>(({
    className,
    type = "text",
    variant,
    size,
    ...props
}, ref) => {
    return (
        <input
            className={cn(
                inputVariants({ variant, size }),
                className,
            )}
            type={type}
            ref={ref}
            suppressHydrationWarning
            {...props}
        />
    );
});

Input.displayName = "Input";

export { Input };
